import moment from "moment";
import React from "react";
import { useTheme } from "../../utils/theme";

export default function Footer() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <>
      <hr className="my-0" />

      <section
        className="py-3 "
        style={isDark ? { backgroundColor: "#000000" } : undefined}
      >
        <div className="container">
          <div className="row g-3 justify-content-center">
            <div className="col-md-12">
              <p>
                <small className="text-body-secondary">
                  <b>Disclaimer:</b> Investments in securities market are subject to market risks. Read all the related documents carefully before investing. Historical performance does not guarantee future performance. Registration granted by SEBI, enlistment as Investment Advisor with exchange, and certification from National Institute of Securities Markets (NISM) do not guarantee performance of the intermediary or provide any assurance of returns to investors.
                </small>
              </p>
              <p>
                <small className="text-body-secondary">
                  EquityPandit Financial Services Private Limited <br />
                  SEBI Registration No.: INA000006688 | Type of registration: Non-Individual | Validity: Perpetual | BSE Enlistment No.: 1684 | CIN: U67120RJ2013PTC041600
                </small>
              </p>
              <p className="mb-0">
                <small className="text-body-secondary">
                  Registered Address: 209 - The Galleria, Near Sanjeev Kumar Auditorium, Pal, Adajan, Surat, Gujarat - 395009
                </small>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className="theme-footer py-2"
        style={isDark ? { backgroundColor: "#000000" } : undefined}
      >
        <div className="text-center">
          <small>
            © Copyright {moment().format("YYYY")}{" "}
            <a
              href="https://equitypandit.in/"
              target="_blank"
              rel="noreferrer"
              className="theme-footer-link"
            >
              Equitypandit Financial Services Private Limited
            </a>
            . All Rights Reserved
          </small>
        </div>
      </section>
    </>
  );
}
